import Main from '@/views/Main.vue';

// 不作为Main组件的子页面展示的页面单独写，如下
export const loginRouter = {
  path: '/login',
  name: 'login',
  meta: {
    title: 'Login - 登录',
    noAuth:true
  },
  component: resolve => {
    require(['@/views/login.vue'], resolve);
  }
};

export const page404 = {
  path: '/*',
  name: 'error-404',
  meta: {
    title: '404-页面不存在',
    noAuth:false
  },
  component: resolve => {
    require(['@/views/error-page/404.vue'], resolve);
  }
};

export const page403 = {
  path: '/403',
  meta: {
    title: '403-权限不足',
    noAuth:false
  },
  name: 'error-403',
  component: resolve => {
    require(['@/views/error-page/403.vue'], resolve);
  }
};

export const page500 = {
  path: '/500',
  meta: {
    title: '500-服务端错误',
    noAuth:false
  },
  name: 'error-500',
  component: resolve => {
    require(['@/views/error-page/500.vue'], resolve);
  }
};

// 作为Main组件的子页面展示但是不在左侧菜单显示的路由写在otherRouter里
export const otherRouter = {
  path: '/',
  name: 'otherRouter',
  component: Main,
  meta: {
    noAuth:false
  },
  children: [
    {
      path: 'home',
      title: {
        i18n: 'home'
      },
      meta: {
        aid:2
      },
      name: 'home_index',
      component: resolve => {
        require(['@/views/home/home.vue'], resolve);
      }
    },

    //运维用户管理
    {
      path: 'user/user',
      title: {
        i18n: 'user'
      },
      meta: {
        aid: 2
      },
      name: 'user_index',
      component: resolve => {
        require(['@/views/menu/user/user_index.vue'], resolve);
      }
    },

    //运维系统管理用户
    {
      path: 'user/admin',
      title: {
        i18n: 'user'
      },
      meta: {
        aid: 2
      },
      name: 'user_admin',
      component: resolve => {
        require(['@/views/menu/user/user_admin.vue'], resolve);
      }
    },

    //部门管理
    {
      path: 'user/department',
      title: {
        i18n: 'department'
      },
      meta: {
        aid: 2
      },
      name: 'user_department',
      component: resolve => {
        require(['@/views/menu/user/user_department.vue'], resolve);
      }
    },

    //课程管理
    {
      path: 'course/course',
      title: {
        i18n: 'course'
      },
      meta: {
        aid: 3
      },
      name: 'course_course',
      component: resolve => {
        require(['@/views/menu/course/course_index.vue'], resolve);
      }
    },

    //章节管理
    {
      path: 'course/chapter',
      title: {
        i18n: 'chapter'
      },
      meta: {
        aid: 3
      },
      name: 'course_chapter',
      component: resolve => {
        require(['@/views/menu/course/chapter_index.vue'], resolve);
      }
    },

    //关卡管理
    {
      path: 'course/barrier',
      title: {
        i18n: 'barrier'
      },
      meta: {
        aid: 3
      },
      name: 'course_barrier',
      component: resolve => {
        require(['@/views/menu/course/barrier_index.vue'], resolve);
      }
    },

    //每日任务管理
    {
      path: 'question/daily',
      title: {
        i18n: 'question'
      },
      meta: {
        aid: 3
      },
      name: 'question_daily',
      component: resolve => {
        require(['@/views/menu/question/daily_index.vue'], resolve);
      }
    },

    //支付管理详细
    {
      path: 'pay/detail',
      title: {
        i18n: 'pay'
      },
      meta: {
        aid: 4
      },
      name: 'pay_daily',
      component: resolve => {
        require(['@/views/menu/pay/detail_index.vue'], resolve);
      }
    },

    //曲目管理
    {
      path: 'music/index',
      title: {
        i18n: 'pay'
      },
      meta: {
        aid: 2
      },
      name: 'music_index',
      component: resolve => {
        require(['@/views/menu/music/music_index.vue'], resolve);
      }
    }
  ]
};

// 作为Main组件的子页面展示并且在左侧菜单显示的路由写在appRouter里
export const appRouter = [
  //运维用户管理
  {
    path: '/user',
    icon: require('../styles/images/user.png'),
    title: '用户管理',
    name: 'user',
    meta: {
      aid: 2
    },
    component: Main,
    children: [{
      path: 'index',
      title: '用户管理',
      name: 'user_user',
      component: resolve => {
        require(['@/views/menu/user/user_user.vue'], resolve);
      }
    }]
  },

  {
    path: '/course',
    icon: require('../styles/images/course.png'),
    title: '课程管理',
    name: 'course',
    meta: {
      aid: 3
    },
    component: Main,
    children: [{
      path: 'phase',
      title: '课程管理',
      name: 'course_phase',
      component: resolve => {
        require(['@/views/menu/course/bigPhase_index.vue'], resolve);
      }
    }]
  },

  {
    path: '/question',
    icon: require('../styles/images/question.png'),
    title: '题库管理',
    name: 'question',
    meta: {
      aid: 3
    },
    component: Main,
    children: [{
      path: 'index',
      title: '题库管理',
      name: 'question_index',
      component: resolve => {
        require(['@/views/menu/question/question_index.vue'], resolve);
      }
    }]
  },

  {
    path: '/music',
    icon: require('../styles/images/question.png'),
    title: '曲库管理',
    name: 'music',
    meta: {
      aid: 3
    },
    component: Main,
    children: [{
      path: 'cate',
      title: '曲库管理',
      name: 'cate_index',
      component: resolve => {
        require(['@/views/menu/music/cate_index.vue'], resolve);
      }
    }]
  },

  {
    path: '/exam',
    icon: require('../styles/images/course.png'),
    title: '考级课程管理',
    name: 'exam',
    meta: {
      aid: 3
    },
    component: Main,
    children: [{
      path: 'index',
      title: '考级课程管理',
      name: 'exam_index',
      component: resolve => {
        require(['@/views/menu/exam/exam_index.vue'], resolve);
      }
    }]
  },

  {
    path: '/school',
    icon: require('../styles/images/school.png'),
    title: '校区管理',
    name: 'school',
    meta: {
      aid: 2
    },
    component: Main,
    children: [{
      path: 'index',
      title: '校区管理',
      name: 'school_index',
      component: resolve => {
        require(['@/views/menu/school/school_index.vue'], resolve);
      }
    }]
  },

  {
    path: '/revenue',
    icon: require('../styles/images/revenue.png'),
    title: '营收管理',
    name: 'revenue',
    meta: {
      aid: 4
    },
    component: Main,
    children: [{
      path: 'index',
      title: '营收管理',
      name: 'revenue_index',
      component: resolve => {
        require(['@/views/menu/revenue/revenue_index.vue'], resolve);
      }
    }]
  },

  {
    path: '/pay',
    icon: require('../styles/images/revenue.png'),
    title: '支付管理',
    name: 'pay',
    meta: {
      aid: 4
    },
    component: Main,
    children: [{
      path: 'index',
      title: '支付管理',
      name: 'pay_index',
      component: resolve => {
        require(['@/views/menu/pay/pay_index.vue'], resolve);
      }
    }]
  },

  {
    path: '/score',
    icon: require('../styles/images/score.png'),
    title: '积分管理',
    name: 'score',
    meta: {
      aid: 6
    },
    component: Main,
    children: [{
      path: 'index',
      title: '积分管理',
      name: 'score_index',
      component: resolve => {
        require(['@/views/menu/score/score_index.vue'], resolve);
      }
    }]
  },

  {
    path: '/log',
    icon: require('../styles/images/log.png'),
    title: '系统日志',
    name: 'log',
    meta: {
      aid: 5
    },
    component: Main,
    children: [{
      path: 'index',
      title: '系统日志',
      name: 'log_index',
      component: resolve => {
        require(['@/views/menu/log/log_index.vue'], resolve);
      }
    }]
  }
];

// 所有上面定义的路由都要写在下面的routers里
export const routers = [
  loginRouter,
  otherRouter,
  ...appRouter,
  page500,
  page403,
  page404
];


// WEBPACK FOOTER //
// ./src/router/router.js